import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/out_25.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image120.webp';
import slideImg2 from '../images/image36.webp';
import slideImg3 from '../images/image97_.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const gulfGateConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Gulf Gate Estates Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Gulf Gate Estates, FL. Sam\'s Tree Service tackles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_gulf_gate_estates',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Gulf Gate Estates',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Gulf Gate Estates Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we know that the established neighborhoods of 
     <strong>Gulf Gate Estates</strong> come with mature, beautiful trees and the challenges 
     that go with them. Large canopies over homes, aging oaks with weakened limbs, and palms 
     leaning toward structures after storms all require experienced hands and the right equipment 
     to handle safely. That's exactly what we bring to every job.`,

    `We specialize in <strong>dangerous and difficult tree work</strong> overgrown canopies 
     threatening roofs and carports, storm damaged limbs, hollow or rotting trunks, and trees 
     growing too close to fences, driveways, or utility lines. We handle the complexity so you 
     don't have to worry.`,

    `<strong>Sam's Tree Service</strong> provides expert, affordable tree care throughout 
     <strong>Gulf Gate Estates</strong> and the surrounding <strong>South Sarasota</strong> 
     area protecting your property and preserving the beauty of your landscape year round.`,
  ],

  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Gulf Gate Estates, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_GulfGateEstates = () => <LocationPage config={gulfGateConfig} />;
export default Services_GulfGateEstates;
